import { Component,ElementRef,ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams,LoadingController,Slides,Events,Platform,AlertController } from 'ionic-angular';
import {BrowserModule, DomSanitizer} from '@angular/platform-browser'
import { MenuController } from 'ionic-angular';
import { Storagehelper } from '../../providers/storagehelper'
import { Commontask } from '../../providers/commontask'

import { ScreenOrientation } from '@ionic-native/screen-orientation';
declare var document;
import { Filetransfer} from '../../providers/filetransfer'
import { SocialSharing } from '@ionic-native/social-sharing';
/**
 * Generated class for the PageVideo page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-page-video',
  templateUrl: 'page-video.html',
})
export class PageVideo extends Commontask {

	@ViewChild(Slides) slides: Slides;
 	@ViewChild('ioncontent') ioncontent: ElementRef;
 	@ViewChild('detailPage') dataContainer: ElementRef;
	private pageid;
	public pageDetail;
	public bgImage;
	private loading;
	public slideIndex;
	public removebckbutton;
	public bckclass;
	public isFavorite;

	constructor(public navCtrl: NavController,public event:Events, public navParams: NavParams,public storage: Storagehelper,public loader:LoadingController,public menuctrl:MenuController,public sanitizer:DomSanitizer,public filetransfer:Filetransfer,public platform:Platform,public socialShare:SocialSharing,public alertCtrl:AlertController,public screenorientation:ScreenOrientation) {
		super(menuctrl,event,platform,socialShare,alertCtrl);
		this.pageDetail={PageTitle:"",slidertasks:[],PageContent:"",bgImageUrl:"",localImageFile:"assets/images/c.png"};
		this.pageid=navParams.get('pageID');
		this.removebckbutton=navParams.get('removebckbutton');
		this.getPageDetail();
	  	this.loading=this.loader.create({
	      spinner:"ios",
	      cssClass:"dreamLoader"
	    });
	    this.isFavorite=false;
	    this.loading.present();
	    this.slideIndex=0;
	    this.unLockOrientation();
		this.getCategoryByCategoryID(storage,navParams);
	   
	}

	unLockOrientation(){
		this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.

		       if(!this.platform.is('core') && !this.platform.is('mobileweb')) {
		          this.screenorientation.unlock();

		          // this.screenorientation.lock(this.screenorientation.ORIENTATIONS.PORTRAIT);
		        }
		      
		    });
	}

	lockOrientation(){
		this.platform.ready().then(() => {
	       if(!this.platform.is('core') && !this.platform.is('mobileweb')) {
				this.screenorientation.lock(this.screenorientation.ORIENTATIONS.PORTRAIT);
	          // this.screenorientation.lock(this.screenorientation.ORIENTATIONS.PORTRAIT);
	        }
	    });
	}

	ionViewWillLeave(){
		this.lockOrientation();
	}



	  ionViewDidEnter() {
	   	this.unLockOrientation();
	  }


	  ionViewDidLoad() {
	    console.log('ionViewDidLoad PageVideo');
	  }


	getPageDetail(){

		this.storage.queryStorage('pagelist','Id',this.pageid).then((data)=>{
			if(data.length>0){
				this.pageDetail=data[0];
				this.checkFavorite();
				if(this.pageDetail.pagelinks.length>0){
					 this.pageDetail.pagelinks.map((e,i)=>{
					 	e.categoryid=this.navParams.get("categoryID");
					 })
				}
	     		// this.dataContainer.nativeElement.innerHTML = this.pageDetail.PageContent;
	     		if(this.pageDetail.backgroundType==1)	{	
	     		if(this.pageDetail.bgImageUrl!="")	{	
	     			var localCheck=this.checkIfBackgroundStatic(this.pageDetail.bgImageUrl);
	     			if(localCheck!=false){
						this.loading.dismiss();
		     			// this.pageDetail.localImageFile=localurl;
		     			//Using javascript to set page background
		     			// document.getElementsByClassName("pageion-content")[document.getElementsByClassName("pageion-content").length-1].style.backgroundImage="url('../assets/images/"+localCheck+".png')"
			     		this.bckclass=localCheck;
	     			}else{

			     		this.filetransfer.saveFileLocally(this.pageDetail.bgImageUrl,"images").then((localurl)=>{
			     			this.loading.dismiss();
			     			this.pageDetail.localImageFile=localurl;
			     			//Using javascript to set page background
			     			document.getElementsByClassName("pageion-content")[document.getElementsByClassName("pageion-content").length-1].style.backgroundImage="url('"+this.pageDetail.localImageFile+"')"	
			     			if(this.pageDetail.Embed!=null && this.pageDetail.Embed!='')
				     			document.getElementsByClassName("embedVideo")[document.getElementsByClassName("embedVideo").length-1].innerHTML=this.pageDetail.Embed;
			     		},(err)=>{
								this.loading.dismiss();
			     			if(err=="browser"){
			     				this.pageDetail.localImageFile = this.pageDetail.bgImageUrl;
			     				//Using javascript to set page background
			     				document.getElementsByClassName("pageion-content")[document.getElementsByClassName("pageion-content").length-1].style.backgroundImage="url('"+this.pageDetail.localImageFile+"')"
			     			}
			     			
			     		});
		     		}

	     		}else{
					this.loading.dismiss();
	     		}
	     		}else{
	     			this.loading.dismiss();
	     			document.getElementsByClassName("pageion-content")[document.getElementsByClassName("pageion-content").length-1].style.backgroundColor="#"+this.pageDetail.backgroundColor;
     				document.getElementsByClassName("pageion-content")[document.getElementsByClassName("pageion-content").length-1].style.backgroundImage="unset";
	     		}
	     		if(this.pageDetail.Embed!=null && this.pageDetail.Embed!=''){
	     			var url=this.pageDetail.Embed;
	     			if(url.indexOf("iframe")==-1){

		     			if(url.indexOf("youtube")!=-1){
		     				url=this.fixYoutubeUrl(url);
		     			}else if(url.indexOf("vimeo")!=-1){
		     				url=this.fixVimeoUrl(url);
		     			}
		     			url='<iframe src="'+url+'" width="640" height="360" frameborder="0" webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen="" style="width: 100%;"></iframe>'
	     			}
	     			document.getElementsByClassName("embedVideo")[document.getElementsByClassName("embedVideo").length-1].innerHTML=url;
	     		}
			}
		})

	}

    private checkFavorite(){
    	this.storage.queryStorage('favoriteTasks','Id',this.pageDetail.Id).then((data)=>{
    		if(data!=null && data.length>0){
    			this.isFavorite=true;
    		}
    	})
    }

  	private  fixYoutubeUrl(url){
     	var ptrn = /(?:http?s?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=)?(.+)/g;
       	if(ptrn.test(url) ){
          var replacement = 'http://www.youtube.com/embed/$1?autoplay=1&rel=0';
          url= url.replace(ptrn, replacement);
      	}; 
      	return url;
    }
    private fixVimeoUrl(url){
        var ptrn = /(?:http?s?:\/\/)?(?:www\.)?(?:vimeo\.com)\/?(.+)/g;
        if(ptrn.test(url)){
           var replacement = 'http://player.vimeo.com/video/$1?autoplay=1';
          url= url.replace(ptrn, replacement);
        }; 
        return url;
    }

    public makeTaskFav(){
    	// this.storage.setStorageItem('favorite')
    	if(!this.isFavorite){
	    	this.storage.deleteItem('favoriteTasks','Id',this.pageDetail.Id).then(()=>{
	    		this.pageDetail.categoryid=this.categoryDetail.category_id;
	    		this.storage.addNewItem('favoriteTasks','FavoriteId',this.pageDetail).then(()=>{
	    			this.isFavorite=true;
				  		let alert=this.alertCtrl.create({
				  			title:this.alertTitle,
				  			message:'Sparat i menyn under favoriter',
				  			buttons:[{
				  				text:'OK',
				  				role:'cancel'
				  			}]
				  		})
				  		alert.present();
    				this.event.publish("app:loadFavoriteItems");
	    		})
	    			
	    	})
    	}else{
    		this.storage.deleteItem('favoriteTasks','Id',this.pageDetail.Id).then(()=>{
	    			this.isFavorite=false;
				  		let alert=this.alertCtrl.create({
				  			title:this.alertTitle,
				  			message:'Borttaget som favorit i menyn ',
				  			buttons:[{
				  				text:'OK',
				  				role:'cancel'
				  			}]
				  		})
				  		alert.present();
    				this.event.publish("app:loadFavoriteItems");
	    			
	    	})
    	}
    }

}



// WEBPACK FOOTER //
// ./src/pages/page-video/page-video.ts